__turbopack_context__.v({
  "carouselIndicator": "theme-module__Mkmp5W__carouselIndicator",
  "container": "theme-module__Mkmp5W__container",
  "input": "theme-module__Mkmp5W__input",
  "menuDropdown": "theme-module__Mkmp5W__menuDropdown",
  "menuItem": "theme-module__Mkmp5W__menuItem",
  "navLink": "theme-module__Mkmp5W__navLink",
  "noInputRing": "theme-module__Mkmp5W__noInputRing",
  "numberInput": "theme-module__Mkmp5W__numberInput",
});
